import script from "./PriceingTariffElecV2.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceingTariffElecV2.vue?vue&type=script&lang=ts&setup=true"

import "./PriceingTariffElecV2.vue?vue&type=style&index=0&id=f3afb9b2&lang=scss&scoped=true"
import "./PriceingTariffElecV2.vue?vue&type=style&index=1&id=f3afb9b2&lang=css"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3afb9b2"]])

export default __exports__